import { useTranslation } from 'react-i18next';
import { NexaMark } from './nexa-mark';
import { usePrefersReducedMotion } from './use-prefers-reduced-motion';
import '@/i18n';

export interface NexaBootSplashProps {
  label?: string;
  caption?: string | undefined;
  reducedMotion?: boolean | undefined;
}

export function NexaBootSplash({ label, caption, reducedMotion }: NexaBootSplashProps) {
  const { t } = useTranslation();
  const resolved = label ?? t('nexa.loading');
  const staticSplash = usePrefersReducedMotion(reducedMotion);

  return (
    <div
      role="progressbar"
      aria-busy="true"
      aria-label={resolved}
      aria-valuetext={resolved}
      data-testid="nexa-boot-splash"
      className={`nexa-boot-splash fixed inset-0 z-[100] flex flex-col items-center justify-center overflow-hidden bg-background ${
        staticSplash ? 'nexa-boot-splash--static' : ''
      }`}
    >
      <div className="nexa-boot-splash__stage relative flex flex-col items-center">
        <div className="relative flex items-center justify-center">
          <NexaMark variant="splash" reducedMotion={reducedMotion} />
        </div>
        <p className="mt-6 text-xs uppercase tracking-[0.28em] text-muted-foreground">{resolved}</p>
        {caption ? (
          <p className="mt-3 max-w-md px-6 text-center text-sm text-muted-foreground/80">{caption}</p>
        ) : null}
      </div>
    </div>
  );
}
